import { OrganizationRequired } from "components/UserManagement//interfaces"

export const initialFormData: OrganizationRequired = {
	name: "",
	description: "",
	vendors: [],
	plans: [],
	brands: [],
	categories: [],
}

export const initialDisabledData = {
	name: false,
	description: false,
	vendors: false,
	plans: false,
	brands: true,
	categories: true,
}

export const debouncedTime = 500
